import { Suspense, lazy } from 'react';

import { useFeatureFlag } from '@spotify/confidence-core-react';

const LazyTourResumer = lazy(() => import('./TourResumer'));

export const TourResumer = () => {
  const { enabled } = useFeatureFlag('onboarding-tours', { enabled: false });

  if (!enabled) return null;

  return (
    <Suspense fallback={null}>
      <LazyTourResumer />
    </Suspense>
  );
};
